import { render, staticRenderFns } from "./DropdownRouterLink.vue?vue&type=template&id=1184f0b8"
import script from "./DropdownRouterLink.vue?vue&type=script&lang=js"
export * from "./DropdownRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports